import { permissions } from "./Clients/permissions/const";
import {
  Food,
  Apks,
  Admins,
  Clients,
  Dashboard,
  Maintenance,
  Notifications,
  TrayTemplates,
  FeedersControls,
  MovementsHistorical,
  Region,
  Organization,
  Waterwises,
  Hydros,
  AdminDietsMenu,
  Restore
} from "./constant/admin";
import {
  Farms,
  Diets,
  Alerts,
  Devices,
  FarmDashboard,
  Data,
  HumanResources,
  Operations,
  cycles_plantings,
  UsersPermissions,
  Comparison
} from "./constant/clients";
import { FREE_NAS_VIEW, FreeNasPonds } from "./constant/free-nas";

export class Menu {
  constructor() {}
  /* client_permissions es solo para subclientes
son permisos del cliente a considerar */
  public static menu(params) {
    const { user, mode, my_permissions, client_permissions, farm_id, status_cycle = 1 } = params;

    const arraySUperUsuario = [
      Dashboard,
      Admins,
      Organization,
      Clients,
      FeedersControls,
      Food,
      TrayTemplates,
      Maintenance,
      MovementsHistorical,
      Notifications,
      Apks,
      Waterwises,
      Hydros,
      Region,
      AdminDietsMenu,
      Restore
    ];

    let ArrayCliente: any = [
      FarmDashboard,
      Farms,
      Alerts,
      Diets,
      Devices,
      Data,
      HumanResources,
      Operations,
      cycles_plantings,
      Comparison
    ];
    /* Sin ciclos: se entra al modulo unificado, que ofrece la creacion desde su encabezado */
    const not_cycle = [cycles_plantings, Alerts, Devices, HumanResources, UsersPermissions];
    const cycle_not_started = [cycles_plantings, Alerts, Devices, HumanResources, UsersPermissions];

    const array_finished_cycle = [cycles_plantings, Alerts, Devices, HumanResources, Data];

    let ArraySubcliente = [...ArrayCliente];
    /* Sustituimos HumanResources por el apartado de Permisos */
    ArraySubcliente.splice(6, 1, UsersPermissions);

    let sidebar_section = localStorage.getItem("sidebar_section");
    let arraySection = sidebar_section ? JSON.parse(sidebar_section) : [];

    const ValidateSection = (array, sections) => {
      if (sections.length > 0) {
        let findSidebarAlert = sections.find((item) => item === "sidebar_alert");
        let findSidebarFeeders = sections.find((item) => item === "sidebar_feeders");

        const validateUrl = (item, url) => {
          if (item.hasOwnProperty("submenu")) {
            return item.submenu.find((submenu) => submenu.link === url);
          } else {
            return item.link === url;
          }
        };

        if (findSidebarAlert) {
          let indexMenu = array.findIndex((item) => validateUrl(item, "/alerts"));

          if (indexMenu >= 0 && !array[indexMenu].hasOwnProperty("submenu")) {
            array.splice(indexMenu, 1);
          }
        }

        if (findSidebarFeeders) {
          let indexMenu = array.findIndex((item) => validateUrl(item, "/alimentadoras"));

          if (indexMenu >= 0 && array[indexMenu].hasOwnProperty("submenu")) {
          }
          if (indexMenu >= 0 && !array[indexMenu].hasOwnProperty("submenu")) {
            array.splice(indexMenu, 1);
          }
        }
      }

      return array;
    };
    const validate_permissions_with_farm = (permission) => {
      if (my_permissions) {
        /* Valida si los permisos existen en algun subcliente */
        const validate = Object.prototype.hasOwnProperty.call(my_permissions, permission);
        if (validate) {
          return (
            my_permissions[permission].some((item) => Number(item) === Number(farm_id)) ||
            my_permissions[permission].length === 0
          );
        }
        return false;
      }
      return false;
    };
    /* FUNCION PARA VALIDAR SI PUEDE MOSRAR UNA PANTALLA EN ESPECIFICO */

    const validation_permisions = (item) => {
      const permissionKey = item.permission;

      // Usuarios no subclientes y tipo 0 siempre tienen acceso
      if (!user.is_subclient && user.user_type === 0) return true;

      // Verificar si el permiso pertenece al cliente
      const clientDependentPermission = permissions.client.find((perm) =>
        perm.permissions.includes(permissionKey)
      );

      if (user.is_subclient) {
        const existsInClient =
          client_permissions &&
          Object.prototype.hasOwnProperty.call(client_permissions, permissionKey);

        // Si debe validarse también el subcliente
        if (
          clientDependentPermission &&
          clientDependentPermission.include_subclient &&
          existsInClient
        ) {
          return validate_permissions_with_farm(permissionKey);
        }

        // Si no existe en cliente o no requiere validación con subcliente
        return validate_permissions_with_farm(permissionKey);
      }

      // Usuario tipo 1 (por ejemplo, subcliente directo)
      if (user.user_type === 1) {
        if (item.use_client && my_permissions) {
          return Object.prototype.hasOwnProperty.call(my_permissions, permissionKey);
        }
        return true;
      }

      // Acceso por defecto
      return true;
    };

    /* Funcion para validar los submenus con sus respectivos permisos */
    const validatePermissionsSubclient = (array) => {
      const submenuValidated = array.map((item) => {
        if (item.submenu) {
          return {
            ...item,
            submenu: item.submenu.filter(validation_permisions)
          };
        }
        return item;
      });

      const filteredArray = submenuValidated.filter((item) => {
        const hasValidSubmenu = item.submenu?.length > 0;

        const shouldValidatePermission =
          item.permission !== null &&
          my_permissions !== null &&
          client_permissions !== null &&
          user.use_permissions;

        if (hasValidSubmenu) return true;
        if (shouldValidatePermission) return validation_permisions(item);

        return true;
      });

      return filteredArray;
    };

    const validatePermissionsClient = (array) => {
      /* PERMISOS OBLIGATORIOS A CONSIDERAR EN CLIENTE SIDEBAR */

      const validateClient = (permission) => {
        if (my_permissions) {
          const exist_in_client = Object.prototype.hasOwnProperty.call(my_permissions, permission);
          return exist_in_client;
        }
        return true;
      };
      const validate_submenu = [...array]
        .filter((menu) => {
          if (menu.use_client) {
            return validateClient(menu.permission);
          }
          return true;
        })
        .map((item) => {
          if (item.submenu && item.submenu.length > 0) {
            return {
              ...item,
              submenu: item.submenu.filter((submenu) => {
                if (submenu.use_client) {
                  return validateClient(submenu.permission);
                }
                return true;
              })
            };
          }
          return item;
        });
      return validate_submenu;
    };
    const handleCyclePermissions = (defaultview) => {
      const permissionMap = {
        2: not_cycle,
        3: array_finished_cycle,
        4: cycle_not_started,
        5: array_finished_cycle
      };

      const selectedPermissions = permissionMap[status_cycle];

      return selectedPermissions ? validatePermissionsSubclient(selectedPermissions) : defaultview;
    };

    switch (user.user_type) {
      /* Super Usuario */
      case -1:
        if (!mode) {
          let array = arraySUperUsuario.slice(0);
          return ValidateSection(array, arraySection);
        } else {
          ArrayCliente.push(MovementsHistorical);
          return handleCyclePermissions(ValidateSection(ArrayCliente, arraySection));
        }

      /* Administrador */
      case 0: {
        const { permissions } = user;

        if (permissions.alerts_only) {
          return [Maintenance];
        }

        const array: any[] = [Dashboard];

        const addItem = (cond: boolean | undefined, items: any[]) => {
          if (cond) array.push(...items);
        };

        addItem(permissions.users, [Admins, Organization, Clients, MovementsHistorical]);
        addItem(permissions.monitoring, [Maintenance]);
        addItem(permissions.feeders, [FeedersControls]);
        addItem(permissions.food, [Food]);
        addItem(permissions.trays_template, [TrayTemplates]);

        addItem(permissions.notifications, [Notifications]);
        addItem(permissions.apks, [Apks]);
        addItem(permissions.waterwises, [Waterwises]);
        addItem(permissions.admin_hydros, [Hydros]);

        addItem(permissions.smart_feeding, [Region]);
        addItem(permissions.admin_diets, [AdminDietsMenu]);
        addItem(permissions.restore, [Restore]);
        /* TODO: quitar el "true ||" cuando termine de probarse el modulo de Planes */
        // addItem(true || permissions.plans, [Planes]);

        return mode
          ? handleCyclePermissions(ValidateSection(ArrayCliente, arraySection))
          : ValidateSection(array, arraySection);
      }

      /* Cliente */
      case 1:
        if (FREE_NAS_VIEW) return [FreeNasPonds];
        const view = [...ArrayCliente, ...arraySection];
        /* El historial de pagos no depende del estado del ciclo y es exclusivo del cliente */
        /* Historial de pagos oculto: el cliente aun no debe ver nada de suscripciones */
        // return [...handleCyclePermissions(validatePermissionsClient(view)), PaymentHistory];
        return handleCyclePermissions(validatePermissionsClient(view));
      case 2:
        if (FREE_NAS_VIEW) return [FreeNasPonds];
        return handleCyclePermissions(validatePermissionsSubclient(ArraySubcliente));

      /*   const sub = validatePermissionsClient(ArraySubcliente, permissions);
       */
    }
  }
}
